import { AxiosInstance, AxiosPromise } from "axios";
import { BrokenRule } from "./models/apiErrors";
import { uniq } from "lodash/fp";

export default (axiosInstance: AxiosInstance, handleCodes: string[]) => (
  config: any
) => {
  if (axiosInstance.defaults.adapter) {
    return axiosInstance.defaults.adapter(config).catch(async (settlement: any) => {
      if (settlement && settlement.response && settlement.response.data) {
        try {
          const isResponseTypeBlob = config.responseType === "blob";
          const jsonMimeType = "application/json";
          const dataType = settlement.response.data.type;
          const isBlob = settlement.response.data instanceof Blob && dataType !== jsonMimeType;

          const data = (isResponseTypeBlob && !isBlob)
            ? await settlement.response.data.text().then((text: any) => {
              return JSON.parse(text);
            })
            : JSON.parse(settlement.response.data);

          if (
            data.code === "RuleBroken"
          ) {
            if (data.brokenRules.every((br: BrokenRule) =>
              handleCodes.includes(br.name)
            )) {
              const handled = uniq(
                (data.brokenRules as BrokenRule[]).map((br) => br.name)
              );
              return Promise.resolve({
                ...settlement.response,
                handled,
                isHandleBrokenRuleResult: true,
              }) as AxiosPromise;
            }
            else {
              const unhandled = uniq(
                (data.brokenRules as BrokenRule[]).filter((br) => !handleCodes.includes(br.name)).map((br) => br.name)
              );
              return Promise.resolve({
                ...settlement.response,
                unhandled,
                isHandleBrokenRuleResult: false,
              }) as AxiosPromise;
            }
          }
        } catch {
          /* ignore, let it fall through */
        }
      }
      throw settlement;
    });
  } else {
    throw new Error("Missing adapter!");
  }
};
